import { formatISO } from 'date-fns';

export const buildCurrentDateTime = () => {
  return formatISO(new Date());
};
